import type { FC } from 'react';

import { Shadow } from '@eneco/custom-components/Registration';
import useDC from '@eneco/dc/useDC';
import { Box, EnecoLogo, NavLink, OxxioLogo, PageGrid, Stack, WoonenergieLogo } from '@eneco/sparky';
import { DC_Repositories_Base_Enumerations_Label } from '@monorepo-types/dc';
import { useContent } from '@sitecore/common';
import { RegistrationHeaderRendering } from '@sitecore/types/RegistrationHeader';

const getLogo = (label: DC_Repositories_Base_Enumerations_Label) => {
  switch (label) {
    case 'oxxio':
      return OxxioLogo;
    case 'woonenergie':
      return WoonenergieLogo;
    case 'eneco':
    default:
      return EnecoLogo;
  }
};

const RegistrationHeader: FC = () => {
  const { label } = useDC();
  const { f } = useContent<RegistrationHeaderRendering>();
  const Logo = getLogo(label);
  return (
    <Shadow>
      <Box backgroundColor="backgroundPrimary" paddingY="3">
        <PageGrid>
          <PageGrid.Item gridColumn="1/-1">
            <Stack direction="row" alignX="justify" alignY="center">
              <Logo />
              <Stack direction="row" gap="4">
                <NavLink href={f(`customerServiceLink.value.href`)} variant="tertiary">
                  {f(`customerServiceLink.value.text`)}
                </NavLink>
              </Stack>
            </Stack>
          </PageGrid.Item>
        </PageGrid>
      </Box>
    </Shadow>
  );
};

export default RegistrationHeader;
